// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"328":"4a3c3af3","404":"3e394b3a"}[chunkId] + ".css";
};